<template>
<!-- 搜索推荐 -->
<section class="viewContainer">
  <div v-show="isOrder" @listenEdit="showOrder">
    <!-- 搜索/查询 -->
    <div class="main_container">
      <div class="fuji" @click="show3 = !show3">
        <div class="goodslist1">
          <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
          <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
        </div>
        <div style="position: absolute;right:0;top:-10px" class="sanjiao"/>
      </div>
      <!-- 顶部搜索框 -->
      <el-collapse-transition>
        <div v-show="show3">
          <el-form :model="filters" class="findform">
            <el-form-item label="关键词：" style="display:flex;width:25%">
              <el-input v-model="filters.keyWord" placeholder="请输入关键词" maxlength="10" style="width:90%;"/>
            </el-form-item>
            <el-form-item label="操作时间：" style="display:flex;width:25%;">
              <el-date-picker type="daterange" v-model="filters.operationTime" value-format="yyyy-MM-dd" style="width:90%;"
              @change="changeActiveTime" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"/>
            </el-form-item>
            <el-form-item label="所属城市：" style="display:flex;width:25%;">
              <el-cascader v-model="filters.chengshi" placeholder="请选择城市" :options="options"
                style="width:90%" filterable clearable @change="handleChange"/>
            </el-form-item>
            <el-form-item> <el-button type="danger" @click="onSubmit">查询</el-button> </el-form-item>
          </el-form>
        </div>
      </el-collapse-transition>
    </div>
    <!--列表-->
    <div class="main_container">
      <section class="model_section">
        <p class="model_top_title">搜索推荐关键词</p>
        <el-button type="danger" @click="showAdd()" style="float: right;margin: 5px 10px 0 0;">新 增</el-button>
      </section>
      <!-- table 列表 -->
      <div class="table_container">
        <el-table :data="searchRecommendationList" stripe border>
          <el-table-column label="序号" align="center" width="100">
            <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
          </el-table-column>
          <el-table-column label="省份" align="center" width="200">
            <template scope="scope">{{scope.row.provinceName}}</template>
          </el-table-column>
          <el-table-column label="城市" align="center" width="200" :show-overflow-tooltip="true">
            <template scope="scope">
              <span class="spanList" style="padding: 0 10px;">{{scope.row.cityName}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作时间" align="center" width="200">
            <template scope="scope">{{scope.row.uTime}}</template>
          </el-table-column>
          <el-table-column label="关键词" align="center">
            <template scope="scope">
              <span class="spanList" :title="scope.row.searchKey">{{scope.row.searchKey}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" align="center" width="235">
            <template scope="scope">
              <span class="handle" @click="cliSeePartner(scope.row)"> <i class="el-icon-view"/> 查看 </span>
              <span class="handle" @click="editArticle(scope.row)"> <i class="el-icon-edit-outline"/> 编辑 </span>
              <span class="handle" @click="deleteData(scope.row)"> <i class="el-icon-delete"/> 删除 </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange"
        :current-page="pageIndex" :page-size="10" :total="totalRowsCount" style="margin:10px 0;float:right"/>
      </div>
    </div>
  </div>

  <!-- 详情页 -->
  <div class="order_watch" v-if="isSeePartnerPopup">
    <el-col :span="24" class="add_order_watch main_container pad_left">
      <section class="model_section">
        <p class="model_top_title">{{ addeditsee }}</p>
        <el-button type="danger" @click="showOrder()" style="float: right;margin: 5px 10px 0 0;">返回</el-button>
      </section>
      <!-- 基本信息 -->
      <div class="watch_msg">
        <el-form class="typeface">
          <el-form-item label="发布城市 :" style="width:30%;" label-width="88px">
            <el-cascader v-model="openCity" placeholder="请选择城市" style="width:80%;cursor:pointer;" @change="handleReleaseCity"
              filterable clearable :options="releaseCityOptions" :props="props" :disabled="disabledArticle || wholeCountry"/>
            <el-checkbox v-model="wholeCountry" :disabled="disabledArticle" style="float: right;">全国</el-checkbox>
          </el-form-item>
          <el-form-item label="热搜词语 :" style="width:50%;" label-width="88px">
            <el-input type="textarea" placeholder="例如：东鹏瓷砖,喜临门床垫,学装修"
              maxlength="200" v-model="hotWords" :disabled="disabledArticle" :rows="5"/>
            <div class="redTips">提示：多个热搜词语用 “，”隔开</div>
          </el-form-item>
          <el-form-item label="热度标签 :" style="width:50%;" label-width="88px">
            <el-input type="textarea" placeholder="这里输入的热搜词语，在小程序前端搜索页面显示时，会出现热的图标。"
              maxlength="200" v-model="heatLabel" :disabled="disabledArticle" :rows="3"/>
            <div class="redTips">提示：热度标签内容，不要和热搜词语重复。</div>
          </el-form-item>
        </el-form>
        <div class="shenheDiv">
          <el-button @click="showOrder()">{{seeSub?"取消":"返回"}}</el-button>
          <el-button type="danger" @click="btnSubmit()" v-show="seeSub">保存</el-button>
        </div>
      </div>
    </el-col>
  </div>

</section>
</template>
<script>
import alertTrends from '../../common/alertTrends.js';
import { provincegetcountys } from "../../api/newOss";
import { getHotSearch, postHotSearch, getHotSearchDetails, putHotSearch, deleteHotSearch } from "../../api/comment";
export default {
  name: 'searchRecommendation',
  mixins: [alertTrends],
  data() {
    return {
      show3: true, // 检索区域默认展开
      recommendId: "", // 推荐id
      isOrder: true, // 列表页
      isSeePartnerPopup: false, // 详情页
      addeditsee: '', // 新增/编辑/查看
      searchRecommendationList: [], // 查询列表
      pageIndex: 1,
      pageSize: 10,
      totalRowsCount: 0,
      
      filters: {
        keyWord: "", // 关键词
        operationTime: "", // 操作时间
        chengshi: "", // 城市
      },
      startTime: "", // 开始时间
      endTime: "", // 结束时间
      options: [],
      provinceId: -1, // 省id
      cityId: -1, // 市id
      disabledArticle: false, // 默认不禁用
      openCity: [], // 发布城市
      releaseCityOptions: [],
      props: { multiple: true }, // 发布城市 支持多选
      wholeCountry: false, // 全国 默认不勾选
      hotWords: "", // 热搜词语
      heatLabel: "", // 热度标签
      seeSub: true, // 保存按钮
    }
  },
  methods: {
    // 查询列表
    getInit() {
      let addParams = {
        Key: this.filters.keyWord, // 关键词
        BeginTime: this.startTime, // 开始时间
        EndTime: this.endTime, // 结束时间
        ProvinceId: this.provinceId, // 省id
        CityId: this.cityId, // 市id
        PageIndex: this.pageIndex,// 页码
        PageSize: this.pageSize // 每页行数
      };
      getHotSearch(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            this.searchRecommendationList = data.resultObj.resultObj;
            this.totalRowsCount = data.resultObj.rowsCount;
          } else {
            this.searchRecommendationList = [];
            this.totalRowsCount = 0;
          }
        } else {
          this.searchRecommendationList = [];
          this.totalRowsCount = 0;
        }
      })
    },
    // 返回 显示主页
    showOrder() {
      this.isOrder = true; // 主页
      this.isSeePartnerPopup = false; // 详情页
    },
    // 新增
    showAdd() {
      this.recommendId = "" // 置空id
      this.isOrder = false // 主页
      this.isSeePartnerPopup = true // 详情页
      this.disabledArticle = false
      this.addeditsee='新增';
      this.openCity = [] // 发布城市
      this.wholeCountry = false
      this.hotWords = "" // 热搜词语
      this.heatLabel = "" // 热度标签
      this.seeSub = true
    },
    // 查看 回显数据
    cliSeePartner(row) {
      this.recommendId = row.id // 选中行id
      this.isOrder = false // 主页
      this.isSeePartnerPopup = true // 详情页查看
      this.disabledArticle = true
      this.addeditsee='查看';
      this.seeSub = false
      var addParams = {
        id: this.recommendId // id
      };
      getHotSearchDetails(addParams).then(data => {
        let newResultObj = data.resultObj;
        
        this.openCity = [[newResultObj.provinceId,newResultObj.cityId]] // 发布城市
        this.wholeCountry = newResultObj.isAll; // 全国
        this.hotWords = newResultObj.searchKey; // 热搜词语
        this.heatLabel = newResultObj.hotSearchKey; // 热度标签
      })
    },
    // 编辑
    editArticle(row) {
      this.recommendId = row.id // id
      this.isOrder = false // 主页
      this.isSeePartnerPopup = true // 详情页查看
      this.disabledArticle = false
      this.addeditsee='编辑';
      this.seeSub = true
      var addParams = {
        id: this.recommendId // id
      };
      getHotSearchDetails(addParams).then(data => {
        let newResultObj = data.resultObj;
        
        this.openCity = [[newResultObj.provinceId,newResultObj.cityId]] // 发布城市
        this.wholeCountry = newResultObj.isAll; // 全国
        this.hotWords = newResultObj.searchKey; // 热搜词语
        this.heatLabel = newResultObj.hotSearchKey; // 热度标签
      })
    },
    // 提交
    btnSubmit() {
      if (this.wholeCountry == false && this.openCity.length == 0) {
        this.showAlert('请选择发布城市');
        return false;
      }
      if(this.hotWords == ""){
        this.showAlert('请输入热搜词语');
        return false;
      }
      if(this.heatLabel == ""){
        this.showAlert('请输入热度标签');
        return false;
      }
      if(this.recommendId) {
        var addParams = {
          id: this.recommendId, // id
          cUser: localStorage.Id, // 操作人id
          cityIds: this.openCity.map(item=>item[1]), // 发布城市id，以逗号分隔
          isAll: this.wholeCountry, // 是否勾选全国 true=是、false=否
          searchKey: this.hotWords, // 热搜词语 (非热词)
          hotSearchKey: this.heatLabel, // 热搜标签 (热词)
        };
        putHotSearch(addParams).then(data => {
          if(data.resultCode == 1) {
            this.showAlert(data.resultMsg, 'success');
            this.showAlert('请输入热度标签');
            this.isOrder = true; // 主页
            this.isSeePartnerPopup = false; // 详情页
            this.getInit();
          } else {
            this.showAlert(data.resultMsg);
          }
        })
      } else {
        var addParams = {
          cUser: localStorage.Id, // 操作人id
          cityIds: this.openCity.map(item=>item[1]), // 发布城市id，以逗号分隔
          isAll: this.wholeCountry, // 是否勾选全国 true=是、false=否
          searchKey: this.hotWords, // 热搜词语 (非热词)
          hotSearchKey: this.heatLabel, // 热搜标签 (热词)
        };
        postHotSearch(addParams).then(data => {
          if(data.resultCode == 1) {
            this.showAlert(data.resultMsg, 'success');
            this.isOrder = true; // 主页
            this.isSeePartnerPopup = false; // 详情页
            this.getInit();
          } else {
            this.showAlert(data.resultMsg);
          }
        })
      }
    },
    // 单条删除-列表数据
    deleteData(row){
      this.$swal({
      type:'warning',
      text: '重要信息，你确定要删除吗？',
      showCancelButton:true,
      cancelButtonText: '取消',
      confirmButtonText: '确定',
      }).then(res=>{
        if(res.value){
          var obj = row.id
          deleteHotSearch(obj).then(data=>{
            if(data.resultCode == 1){
              this.showAlert("操作成功", 'success');
              this.getInit();
            }
          })
        }
      })
    },
    // 重置
    fnReset() {
      this.filters = {
        keyWord: "", // 关键词
        operationTime: "", // 操作时间
        chengshi: "", // 城市
      }
      this.startTime = "";
      this.endTime = "";
      this.provinceId = -1;
      this.cityId = -1;
      // this.pageIndex = 1;
      // this.getInit();
    },
    // 操作时间
    changeActiveTime(time) {
      this.startTime = time[0];
      this.endTime = time[1];
    },
    // 请选择省市
    handleChange(val) {
      this.provinceId = val[0];
      this.cityId = val[1];
    },
    // 查找省市
    getprovince() {
      var loginParams = {
        isopen: -1, // 是否开放 -1=查全部 1=开放、0=未开放
      };
      provincegetcountys(loginParams).then((data) => {
        let that = this;
        let cityList = [];
        data.resultObj.forEach((item) => {
          let cityData = { value: item.pid, label: item.pname, children: [] };
          cityList.push(cityData);
          item.citys.map((city) => {
            cityData.children.push({ value: city.cid, label: city.cname });
          });
        });
        that.options = JSON.parse(JSON.stringify(cityList));
        // that.options.map(item => {
        //   if(item.children.length > 1){
        //     item.children.unshift({ value: -1, label: '全部' });
        //   }
        // })
        that.options.unshift({ value: 0, label: '全国' });
        that.releaseCityOptions = cityList;
      })
    },
    // 请选择发布城市
    handleReleaseCity(val) {
      this.openCity = val
    },
    //查询
    onSubmit() {
      this.pageIndex = 1;
      this.getInit();
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getInit();
    },
  },
  watch: {
    'wholeCountry'(newV,oldV) {
      if(this.wholeCountry == true) {
        this.openCity = []
      }
    },
  },
  created() {
    this.getInit(); // 查询列表
    this.getprovince(); // 城市
  }
}
</script>
<style scoped lang="less">
/* 基本信息 */
.watch_msg {
  width: 96%;
  margin: 0 auto;
}
.typeface {
  margin-top: 30px;
}
/* 操作按钮 */
.shenheDiv {
  width: 100%;
  text-align: center;
  margin: 10px 0 20px 0;
}
</style>


// WEBPACK FOOTER //
// searchRecommendation.vue?7e0bb002